import { render, staticRenderFns } from "./NicoHeader.vue?vue&type=template&id=1ef69f20&scoped=true&"
import script from "./NicoHeader.vue?vue&type=script&lang=js&"
export * from "./NicoHeader.vue?vue&type=script&lang=js&"
import style0 from "./NicoHeader.vue?vue&type=style&index=0&id=1ef69f20&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef69f20",
  null
  
)

export default component.exports